var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',_vm._g({class:{
		'text-connectProBlue': _vm.active,
		'text-gray-500': !_vm.active,
		'cursor-pointer': !_vm.disabled,
	},attrs:{"size":"lg","icon":['fas', _vm.active ? 'toggle-on' : 'toggle-off']}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }